// @ts-ignore
import SlimSelect from 'slim-select';

export class MultiSelect {
    select: HTMLElement;

    constructor(select: HTMLElement) {
        this.select = select;
        this.init();
    }

    init() {
        new SlimSelect({
            select: this.select,
            showSearch: false,
            placeholderText: 'Auswählen',
            placeholder: 'Auswählen',
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-multi-select]').forEach(value => {
        new MultiSelect(value);
    })
})
